import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { BasicForm } from 'src/app/shared/basic-form';
import { getFromLocalStorage, setToLocalStorage } from 'src/app/shared/helpers';

@Component({
  selector: 'app-add-passenger-form',
  templateUrl: './add-passenger-form.component.html',
  styleUrls: ['./add-passenger-form.component.scss']
})
export class AddPassengerFormComponent extends BasicForm implements OnInit {

  minDate: Date;
  maxDate: Date;
  more = false;
  ageRestriction = false;
  age: number;

  ngOnInit(): void {
    this.minDate = new Date();
    this.maxDate = new Date();
    this.formAlias = 'PassengerInfo';
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.pattern('^[a-zA-Z]*$')]],
      surname: ['', [Validators.required, Validators.pattern('^[a-zA-Z]*$')]],
      personalNumber: ['', [Validators.required, Validators.pattern('[0-9]+'), Validators.minLength(11), Validators.maxLength(11)]],
      birthDate: [null as Date, Validators.required],
    });

    this.minDate = new Date();
    this.minDate.setFullYear(this.minDate.getFullYear() - 100);
  }

  scroll(e) {
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    document.querySelector(e).scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
}

  onSubmit() {
    let dateValue = this.form.get('birthDate').value;
    this.age = this.getAgeAfterTravel(dateValue, this.policy.InsurancePeriod.endDate);

  //check if passenger with same personalNumber exists
   if(Object.keys(this.formData).length !== 0) {
    if(this.formData.find(o => o.personalNumber === this.form.get('personalNumber').value)) {
      this.form.controls['personalNumber'].setErrors({'incorrect': true});
    }
   } else if(this.policy.PersonalInfo.personalNumber === this.form.get('personalNumber').value) {
    this.form.controls['personalNumber'].setErrors({'incorrect': true});
   }else {
    this.form.controls['personalNumber'].setErrors(null);
  }
    if (!this.form.valid) {
      this.submitted = true;
    } 
    else if(this.age > 69)
    {
      this.submitted = false;
    }
    else if ((!(JSON.parse(JSON.stringify(getFromLocalStorage('policy')))).PassengerInfo
        || (JSON.parse(JSON.stringify(getFromLocalStorage('policy')))).PassengerInfo.length < 5)) {
          if ((JSON.parse(JSON.stringify(getFromLocalStorage('policy')))).PassengerInfo) {
            const formValuesArray = (JSON.parse(JSON.stringify(getFromLocalStorage('policy')))).PassengerInfo;
            formValuesArray.push(this.form.value);
            setToLocalStorage('policy', this.formAlias, formValuesArray);
            this.stepService.nextStep();
          } else {
            const formValuesArray: Array<any> = getFromLocalStorage(JSON.stringify('policy')) || [];
            formValuesArray.push(this.form.value);
            setToLocalStorage('policy', this.formAlias, formValuesArray);
            this.stepService.nextStep();
          }
    } else {
      this.more = true;
    }
  }
}
